module.exports = __webpack_public_path__ + "static/media/aquarium.bab737a9.png";